import type { Message, MessageJsonButtons, RateLimitErrorResponse } from './messages';

export const getIsMessageJson = (messageJson: string | null | MessageJsonButtons) => {
  return typeof messageJson === 'object' && messageJson !== null;
};

/** Проверка на наличие кнопок в messageJson */
export const isMessageJsonButtons = (
  messageJson: string | null | MessageJsonButtons
): messageJson is MessageJsonButtons => {
  const isMessageJson = getIsMessageJson(messageJson);

  return isMessageJson && 'buttons' in messageJson && Array.isArray((messageJson as MessageJsonButtons).buttons);
};

/** Наличие флажка, что пришел рейтинг CSAT звездочками */
export const hasCsatRatingTrigger = (message: Message): boolean => {
  return (
    isMessageJsonButtons(message.messageJson) && message.messageJson.buttons.flat().some((button) => button.isRating)
  );
};

/** Наличие кнопок в сообщении */
export const hasMessageButtons = (message: Message): boolean => {
  return isMessageJsonButtons(message.messageJson) && message.messageJson.buttons.length > 0;
};

/** Проверка, является ли ошибка ошибкой rate limit */
export const isRateLimitError = (error: unknown): error is RateLimitErrorResponse => {
  return error !== null && typeof error === 'object' && 'isRateLimit' in error;
};
